import { EnvironmentIcon, ExcludedEnvironmentIcon, ProjectIcon, MachineIcon, WorkerPoolIcon, DynamicWorkerPoolIcon, WorkerIcon, ExcludedMachineIcon, UnhealthyMachineIcon, UnavailableMachineIcon, ShellNameIcon, DeploymentProcessIcon, RunbookProcessIcon, GitIcon, GitTagIcon, GitBranchIcon, } from "@octopusdeploy/design-system-octopus-components";
import type { EmbeddedImageDescription, VariantDescription } from "~/components/DevTools/Images/EmbeddedImageDescription";
const baseIcons = {
    EnvironmentIcon,
    ExcludedEnvironmentIcon,
    ProjectIcon,
    MachineIcon,
    WorkerPoolIcon,
    DynamicWorkerPoolIcon,
    WorkerIcon,
    ExcludedMachineIcon,
    UnhealthyMachineIcon,
    UnavailableMachineIcon,
    ShellNameIcon,
    DeploymentProcessIcon,
    RunbookProcessIcon,
    GitIcon,
    GitTagIcon,
    GitBranchIcon,
};
const variants: VariantDescription[] = Object.entries(baseIcons).map(([componentName, Icon]) => ({
    variantDescription: componentName,
    content: <Icon />,
}));
// This represents every usage of <DeprecatedSvgIcon> in a react component that isn't covered by embeddedSvgDescriptions
export const embeddedSvgIconDescriptions: EmbeddedImageDescription[] = [{ componentName: "BaseIcons", variants }];
